import * as React from 'react'

import { observer } from 'mobx-react'

import Navigator from 'modules/core/components/Navigator'
import i18n from 'modules/core/lib/i18n'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

interface Props {
  document: Document
  documents: Document[]
  index: number
  onCancel: () => void
  onClickBack: () => void
  onClickForward: () => void
}

const NavigatorHeader = ({
  document,
  documents,
  index,
  onCancel,
  onClickBack,
  onClickForward,
}: Props) => {
  const showCounter = documents.length > 1

  return (
    <Navigator
      title={document.filename}
      index={index}
      total={documents.length}
      onCancel={onCancel}
      onClickBack={onClickBack}
      onClickForward={onClickForward}
      showCounter={showCounter}
      closeAriaLabel={i18n.t('documents.modal.close')}
    />
  )
}

export default observer(NavigatorHeader)
